export const EDIT_FUNCTION_MODAL_TRANSLATE_PATH = 'helios.functions.editFunctionModal';
